import http from "../http";
import api from "../../config/api";
import { ConfigResponse } from "../../interfaces/api/config";

/**
 * Service for fetching configuration data from the API
 */
const config = {
  /**
   * Fetches configuration data from the API
   * @returns {Promise<ConfigResponse>} A Promise that resolves to the config response
   */
  getConfig: (): Promise<ConfigResponse> =>
    new Promise((resolve, reject) => {
      http
        .get(api.configs)
        .then((res) => resolve(res as ConfigResponse))
        .catch((e) => reject(e));
    }),
};

export default config;
